import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Loader } from 'screens/analytics/commonComponents';
import styled from 'styled-components';
import { StyledDivider, RelativePositionFullHeightContainer } from 'styles/common';

import { Objective } from 'assets/assetsV1/iconComponents/Objective';

import { Avatar } from 'uiToolkitV1/Avatar';
import { DateComp } from 'uiToolkitV1/DateComp';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { TextBodyLarge, TextLabel } from 'uiToolkitV1/Typography';

import { DrawerKebabMenu } from './common/DrawerKebabMenu';
import { useRequestedFeedBackData } from './hooks/dataHooks';

const StyledBody = styled.div`
  padding: 0px;
  margin: 16px;
  width: 100%;
  overflow: auto;
`;

const Container = styled.div``;

const ListItemLeftComp = (requesterEmployee) => () => (
  <Avatar name={requesterEmployee?.displayName} src={requesterEmployee?.profilePhoto} />
);

const ObjectiveLeftIcon = () => <Objective color="functional.7651BC" />;

const RequestedFeedbackFullCommentDrawer = ({ feedbackId, handleClose }) => {
  const { data, isLoading } = useRequestedFeedBackData({ feedbackId });
  const { continuousFeedback, receiverEmployee, providerEmployee, canDelete } = data ?? {};

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
        }}
      >
        {canDelete && <DrawerKebabMenu feedbackId={feedbackId} handleClose={handleClose} />}
      </Box>
      <RelativePositionFullHeightContainer>
        <Container>
          <StyledDivider
            variant="fullWidth"
            style={{
              backgroundColor: '#D9D9D9',
              height: '1px',
            }}
            thickness={1}
          />
          <StyledBody>
            <Flex justifyContent="space-between" flexDirection="column">
              <Flex>
                <Box m={2} flex={1}>
                  <TextLabel
                    sx={{
                      mb: 2,
                    }}
                  >
                    Requested From
                  </TextLabel>
                  <ListItemComp
                    withoutBackground
                    title={<TextBodyLarge>{providerEmployee?.displayName}</TextBodyLarge>}
                    LeftComponent={ListItemLeftComp(providerEmployee)}
                  />
                </Box>

                <Box m={2} flex={1}>
                  <TextLabel
                    sx={{
                      mb: 2,
                    }}
                  >
                    Requested For
                  </TextLabel>
                  <ListItemComp
                    withoutBackground
                    title={<TextBodyLarge>{receiverEmployee?.displayName}</TextBodyLarge>}
                    LeftComponent={ListItemLeftComp(receiverEmployee)}
                  />
                </Box>
              </Flex>

              <Box m={2}>
                <TextLabel
                  sx={{
                    mb: 2,
                  }}
                >
                  Date
                </TextLabel>
                {continuousFeedback?.requestedDate && (
                  <DateComp date={new Date(continuousFeedback?.requestedDate).valueOf()} />
                )}
              </Box>
              <Box m={2}>
                <TextLabel
                  sx={{
                    mb: 2,
                  }}
                >
                  Request Details{' '}
                </TextLabel>
                <TextBodyLarge>{continuousFeedback?.questionText}</TextBodyLarge>
              </Box>
            </Flex>
            {continuousFeedback?.goal && (
              <Box m={2}>
                <TextLabel
                  sx={{
                    mb: 2,
                  }}
                >
                  Related Goal
                </TextLabel>
                <ListItemComp
                  withoutBackground
                  title={<TextBodyLarge>{continuousFeedback?.goal?.text}</TextBodyLarge>}
                  LeftComponent={ObjectiveLeftIcon}
                />
              </Box>
            )}
          </StyledBody>
        </Container>
      </RelativePositionFullHeightContainer>
    </>
  );
};

export default RequestedFeedbackFullCommentDrawer;
